import { BoxControl, ScreenContainerControl, TextInputControl } from "doshx_controls_web";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Button } from "@heroui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleLocationArrow, faEnvelope, faPhone } from "@fortawesome/pro-regular-svg-icons";
import { send_generic_email } from "../../api/calls/notification/send_generic_email";
import { validateForm } from "../../helpers/validateForm";
import { setMainModal } from "../../reducers/slices/main";
import { Breadcrumb } from "../../components/breadcrumb";
export const ContactUsPage = () => {
    const dispatch = useDispatch();
    const canvasRef = useRef(null);
    const [contactUsData, setContactUsData] = useState({
        to: process.env.CONTACT_SUPPORT_EMAIL_ADDRESS ?? "",
        subject: "",
        from: "",
        template_id: process.env.CONTACT_SUPPORT_TEMPLATE_ID ?? "",
        data: {
            name: "",
            message: "",
        },
    });
    const [isLoadingContactButton, setIsLoadingContactButton] = useState(false);
    const customValidation = {
        from: {
            name: "contact email",
        },
    };
    const { errors, isValid } = validateForm(contactUsData, customValidation);
    const { errors: dataErrors, isValid: dataIsValid } = validateForm(contactUsData.data);
    const sendContactUsEmail = () => {
        setIsLoadingContactButton(true);
        send_generic_email({
            to: contactUsData.to,
            subject: contactUsData.subject,
            from: contactUsData.from,
            template_id: contactUsData.template_id,
            data: {
                name: contactUsData.data.name,
                message: contactUsData.data.message,
            },
        }).then((response) => {
            setIsLoadingContactButton(false);
            dispatch(setMainModal({ title: response.success ? "Done!" : "Something went wrong!", messages: [response.message] }));
        });
    };
    useEffect(() => {
        const canvas = canvasRef.current;
        if (canvas) {
            const context = canvas.getContext("2d");
            context.fillStyle = "#000000";
            context.filter = "blur(0px)";
            context.shadowColor = "#ff0000";
            context.shadowBlur = 0;
            context.fillRect(0, 0, context.canvas.width, 10);
        }
    }, []);
    return (React.createElement("div", null,
        React.createElement(Breadcrumb, { items: [{ label: "Home" }, { label: "Contact Us", active: true }], title: "Contact Us" }),
        React.createElement(ScreenContainerControl, { className: "flex flex-col gap-8" },
            React.createElement("div", { className: "flex flex-col lg:flex-row gap-8 py-8" },
                React.createElement("div", { className: "flex flex-col w-full lg:w-2/5 gap-8 p-8 bg-primary text-white rounded-2xl" },
                    React.createElement("div", { className: "flex flex-col gap-5" },
                        React.createElement("h3", { className: "text-2xl font-semibold" }, "Headquarters"),
                        React.createElement("div", { className: "flex flex-col gap-3" },
                            React.createElement("div", { className: "flex flex-row gap-3 justify-start items-center text-left text-sm text-grey1" },
                                React.createElement(FontAwesomeIcon, { icon: faEnvelope, size: "lg", className: "" }),
                                ContactDetails.general.email),
                            React.createElement("div", { className: "flex flex-row gap-3 justify-start items-center text-left text-sm text-grey1" },
                                React.createElement(FontAwesomeIcon, { icon: faPhone, size: "lg", className: "" }),
                                ContactDetails.general.tel),
                            React.createElement("div", { className: "flex flex-row gap-3 justify-start items-center text-left text-sm text-grey1" },
                                React.createElement(FontAwesomeIcon, { icon: faCircleLocationArrow, size: "lg", className: "" }),
                                React.createElement("div", null,
                                    React.createElement("h5", { className: "font-semibold" }, "Postal Address"),
                                    ContactDetails.general.address.map((line, index) => (React.createElement("div", { key: index }, line))))))),
                    React.createElement("div", { className: "flex flex-col gap-5" },
                        React.createElement("h3", { className: "text-2xl font-semibold" }, "Order Enquiries"),
                        React.createElement("div", { className: "flex flex-col gap-3" },
                            React.createElement("div", { className: "flex flex-row gap-3 justify-start items-center text-left text-sm text-grey1" },
                                React.createElement(FontAwesomeIcon, { icon: faEnvelope, size: "lg", className: "" }),
                                ContactDetails.orders.email),
                            React.createElement("div", { className: "flex flex-row gap-3 justify-start items-center text-left text-sm text-grey1" },
                                React.createElement(FontAwesomeIcon, { icon: faPhone, size: "lg", className: "" }),
                                ContactDetails.orders.tel))),
                    React.createElement("div", { className: "flex flex-col gap-5" },
                        React.createElement("h3", { className: "text-2xl font-semibold" }, "Street Address"),
                        React.createElement("div", { className: "flex flex-col gap-3" },
                            React.createElement("div", { className: "flex flex-row gap-3 justify-start items-center text-left text-sm text-grey1" },
                                React.createElement(FontAwesomeIcon, { icon: faCircleLocationArrow, size: "lg", className: "" }),
                                React.createElement("div", null,
                                    React.createElement("h5", { className: "font-semibold" }, "Postal Address"),
                                    ContactDetails.address.map((line, index) => (React.createElement("div", { key: index }, line)))))))),
                React.createElement(BoxControl, { className: "bg-white w-full lg:w-3/5", variant: "filled", addPadding: false },
                    React.createElement("div", { className: "flex flex-col gap-3" },
                        React.createElement("div", { className: "flex flex-col gap-3 mb-3" },
                            React.createElement("h1", { className: "text-3xl text-primary font-semibold" }, "Contact Us"),
                            React.createElement("div", { className: "text-sm text-primary" }, "Fields marked with an * are required")),
                        React.createElement("div", { className: "grid gap-5\n                        grid-cols-1 lg:grid-cols-2" },
                            React.createElement(TextInputControl, { label: "Your name", value: contactUsData.data.name, onChange: (v) => setContactUsData({
                                    ...contactUsData,
                                    data: {
                                        ...contactUsData.data,
                                        name: v,
                                    },
                                }), errorText: dataErrors.name }),
                            React.createElement(TextInputControl, { label: "Contact email", value: contactUsData.from, onChange: (v) => setContactUsData({
                                    ...contactUsData,
                                    from: v,
                                }), errorText: errors.from }),
                            React.createElement("div", { className: "lg:col-span-2" },
                                React.createElement(TextInputControl, { label: "Subject", value: contactUsData?.subject, onChange: (v) => setContactUsData({
                                        ...contactUsData,
                                        subject: v,
                                    }), errorText: errors.subject })),
                            React.createElement("div", { className: "lg:col-span-2" },
                                React.createElement(TextInputControl, { label: "Your message", lines: 8, value: contactUsData?.data?.message, onChange: (v) => setContactUsData({
                                        ...contactUsData,
                                        data: {
                                            ...contactUsData.data,
                                            message: v,
                                        },
                                    }), errorText: dataErrors.message }))),
                        React.createElement("div", { className: "flex flex-row justify-start" },
                            React.createElement(Button, { color: "primary", size: "lg", fullWidth: true, radius: "md", isDisabled: !isValid && !dataIsValid, isLoading: isLoadingContactButton, onPress: () => sendContactUsEmail() }, "Submit"))))))));
};
export const ContactDetails = {
    general: {
        tel: "+61 7 3881 5777",
        email: "info@scee.edu.au",
        address: ["Southern Cross Educational Enterprises", "PO Box 3102", "Caboolture, QLD, 4510", "Australia"],
    },
    orders: {
        tel: "+61 7 3881 5710",
        email: "orders@scee.edu.au",
    },
    address: ["8-12 Business Drive", "Narangba, QLD, 4504", "Australia"],
};
